// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-B":"Other_outdoor-recreation-B__3YZ_d"};